import React,{useState,useEffect} from 'react'
import * as calc from '../utils/calcolatrice'
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import SelectRuota from './selectRuota';
import TextField from '@mui/material/TextField';
import Tabella from '../calcolatrice/tabella';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { RemoveCircle } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { PDFDownloadLink, Document, Page } from '@react-pdf/renderer';
import Report from './report/report';
import { InputAdornment } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import './index.css'
import Pignone from './Pignone';
import Metro from './Metro'
import Modal from '@mui/material/Modal';

const Calcolatrice = (props) => {

    const {invertiCalcolo,en} = props

    const [ruota,setRuota] = useState(calc.ruote[0])
    const [corona,setCorona] = useState(null)
    const [rpm,setRpm] = useState(null)
    const [pignoni,setPignoni] = useState([])
    const [pignone,setPignone] = useState(null)
    const [showMetro, setShowMetro] = useState(false)

    const [p1,setP1] = useState(null)
    const [p2,setP2] = useState(null)
    const [p3,setP3] = useState(null)
    const [p4,setP4] = useState(null)
    const [p5,setP5] = useState(null)
    const [p6,setP6] = useState(null)
    const [p7,setP7] = useState(null)
    const [p8,setP8] = useState(null)
    const [p9,setP9] = useState(null)
    const [p10,setP10] = useState(null)
    const [p11,setP11] = useState(null)
    const [p12,setP12] = useState(null)
    const [p13,setP13] = useState(null)
    const [p14,setP14] = useState(null)

    const propsToShare = {
      ruota,setRuota,
      corona,setCorona,
      rpm,setRpm,
      pignoni,setPignoni,
      pignone,setPignone,
      showMetro, setShowMetro,
      invertiCalcolo

    }

    const AggiornaPignoni = (pignone) => {

      if(!pignone || isNaN(pignone) || Number(pignone) < 10 || Number(pignone) > 52) return 

      const p = pignoni.find(el => el === Number(pignone))
      if(p && p > 0) return
      setPignoni([...pignoni,Number(pignone)].sort())


    }

    useEffect(() => {

      setPignoni([p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14].filter(el => Number(el) !== 0).sort())


    },[p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14])

    const pList = {
      p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,
      setP1,setP2,setP3,setP4,setP5,setP6,setP7,setP8,setP9,setP10,setP11,setP12,setP13,setP14
    }


    return (
      <div>
      <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h3 style={{textAlign: 'left'}}><strong>{en ? "GEAR DATA" : "DATI CAMBIO"}</strong></h3>
        </Grid>
        <Grid item xs={12}>
        <Stack direction={'column'} spacing={2}>
        <div style={{width: '100%', display: 'flex'}}>
            <h4 style={{margin: 0, width: '130px',textAlign: 'left', marginTop: '10px'}}>{en ? "Wheel*" : "Ruota*"}</h4>
            <SelectRuota ruota={ruota} setRuota={setRuota} listaRuote={calc.ruote}/>
        </div>
        <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <div style={{width: '100%', marginRight: '10px'}}>
              <h4 style={{margin: 0, width: '130px',textAlign: 'left', marginBottom: '10px'}}>{en ? "Chainring*" : "Corona*"}</h4>
              <TextField fullWidth required InputLabelProps={{ shrink: true }} id="corona" size="small" value={corona} onChange={(e) => {setCorona(e.target.value)}}/>
            </div>
            <div style={{width: '100%'}}>
              <h4 style={{margin: 0, width: '130px',textAlign: 'left', marginBottom: '10px'}}>RPM</h4>
              <TextField fullWidth InputLabelProps={{ shrink: true }} id="rpm" size="small" value={rpm} onChange={(e) => {setRpm(e.target.value)}}/>
            </div>
        
        </div>
        
        </Stack>
        </Grid>
        </Grid>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>
        <div style={{width: '600px', display: 'flex'}}>
          <h3 style={{textAlign: 'left'}}>
            {!invertiCalcolo && <strong>{en ? "GEAR RATIO COMPARISON" : "COMPARAZIONE RAPPORTI"}</strong>}
            {invertiCalcolo && <strong>{en ? "BINARY GEAR RATIO DEVELOPMENT" : "SVILUPPO RAPPORTI BINARY"}</strong>}
          </h3>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '10px', border: '2px solid #cf2e2e', borderRadius: '10px', color: '#cf2e2e', cursor: 'pointer', marginBottom: '20px'}} 
        onClick={() => {
          
          if(pignoni.length < 1) return

          setShowMetro(!showMetro)
        }}>
          {showMetro ? "CHIUDI VISUALIZZAZIONE GRAFICA" : "APRI VISUALIZZAZIONE GRAFICA"}
        </div>
        <div style={{width: '200px', height: '40px', backgroundColor: '#cf2e2e', color: 'white',padding: '10px', borderRadius: '10px', cursor: 'pointer'}}>
                  <PDFDownloadLink document={<Report invertiCalcolo={invertiCalcolo} en={en} ruota={ruota} corona={corona} rpm={rpm} pignoni={[...pignoni]} setPignoni={setPignoni}/>} fileName="Report_MagneticDays_Binary.pdf">
              {({ blob, url, loading, error }) =>
                loading ? <span style={{color: 'white'}}>WAITING...</span> : <span style={{color: 'white'}}>DOWNLOAD</span>
              }
            </PDFDownloadLink>
          </div>
        </div>
        <h4>Inserisci la tua serie di pignoni</h4>
        <Stack direction={'row'} flexWrap={'wrap'} marginBottom={'20px'} justifyContent={'center'}>

       {/*  <TextField InputLabelProps={{ shrink: true }}  size="small" value={p1}  onChange={(e) => {setP1(e.target.value)}} style={{maxWidth: '50px', marginRight: '5px', marginBottom: '5px'}}/>
        <TextField InputLabelProps={{ shrink: true }}  size="small" value={p2}  onChange={(e) => {setP2(e.target.value)}} style={{maxWidth: '50px', marginRight: '5px', marginBottom: '5px'}}/>
        <TextField InputLabelProps={{ shrink: true }}  size="small" value={p3}  onChange={(e) => {setP3(e.target.value)}} style={{maxWidth: '50px', marginRight: '5px', marginBottom: '5px'}}/>
        <TextField InputLabelProps={{ shrink: true }}  size="small" value={p4}  onChange={(e) => {setP4(e.target.value)}} style={{maxWidth: '50px', marginRight: '5px', marginBottom: '5px'}}/>
        <TextField InputLabelProps={{ shrink: true }}  size="small" value={p5}  onChange={(e) => {setP5(e.target.value)}} style={{maxWidth: '50px', marginRight: '5px', marginBottom: '5px'}}/> */}
        
         <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
          <Pignone pignone={p1} setPignone={setP1}/>
          <Pignone pignone={p2} setPignone={setP2}/>
          <Pignone pignone={p3} setPignone={setP3}/>
          <Pignone pignone={p4} setPignone={setP4}/>
          <Pignone pignone={p5} setPignone={setP5}/>
         </div>
         <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center'}}>
          <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center'}}>
            <Pignone pignone={p6} setPignone={setP6}/>
            <Pignone pignone={p7} setPignone={setP7}/>
            <Pignone pignone={p8} setPignone={setP8}/>
            <Pignone pignone={p9} setPignone={setP9}/>
            <Pignone pignone={p10} setPignone={setP10}/>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center'}}>
            <Pignone pignone={p11} setPignone={setP11}/>
            <Pignone pignone={p12} setPignone={setP12}/>
            <Pignone pignone={p13} setPignone={setP13}/>
            <Pignone pignone={p14} setPignone={setP14}/>
          </div>

         </div>
         
         
        

        </Stack>
        <Stack direction={'row'} spacing={2} style={{marginBottom: '20px'}} display={'none'}>
          <h4 style={{margin: 0, width: '250px',textAlign: 'left', marginTop: '10px'}}>{en ? "Add sprocket" : "Aggiungi pignone"}</h4>
          <TextField InputLabelProps={{ shrink: true }} label={en ? "Add sprocket" : "Aggiungi pignone"} id="pignone" size="small" value={pignone} onChange={(e) => {setPignone(e.target.value)}} fullWidth/>
          <div style={{width: '200px', height: '40px', backgroundColor: 'gray', color: 'white',padding: '10px', borderRadius: '10px', cursor: 'pointer'}}
          onClick={() => {

              if(!pignone || pignone < 1) return

              console.log(pignone)


              const p = pignoni.find(el => el === Number(pignone))

              console.log(p)
              if(p && p > 0) return

              setPignoni([...pignoni,Number(pignone)].sort())

              console.log(pignoni)

              }}>
          {en ? "ADD" : "AGGIUNGI"}
          </div>

        </Stack>
        {(!showMetro) && <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', flexDirection: (invertiCalcolo) ? 'row-reverse' : 'row'}}>
          <div className='column'>
            <Tabella ruota={ruota} corona={corona} rpm={rpm} binary={true} pignoni={[...pignoni]} setPignoni={setPignoni} en={en} invertiCalcolo={invertiCalcolo} {...pList}/>
          </div>
          <div className='column'>
            <Tabella ruota={ruota} corona={corona} rpm={rpm} pignoni={[...pignoni]} setPignoni={setPignoni} en={en} invertiCalcolo={invertiCalcolo} {...pList}/>
          </div>
        </div>}
        {showMetro && <Metro {...propsToShare}/>}

      </Container>
      </div>
    
    )



    return (<Container maxWidth="lg">
    <Stack direction={'column'} spacing={2}>
    <h3><strong>DATI CAMBIO</strong></h3>
    <Stack direction={'row'} spacing={2} justifyContent={'center'}>
      <Stack direction={'column'} spacing={2}>
          <SelectRuota ruota={ruota} setRuota={setRuota} listaRuote={calc.ruote}/>
          <TextField fullWidth InputLabelProps={{ shrink: true }} label="Corona" id="corona" size="small" value={corona} onChange={(e) => {setCorona(e.target.value)}}/>
          <TextField fullWidth InputLabelProps={{ shrink: true }} label="Rpm" id="rpm" size="small" value={rpm} onChange={(e) => {setRpm(e.target.value)}}/>
      </Stack>
      <Stack direction={'row'} spacing={2}>
        <TextField InputLabelProps={{ shrink: true }} label="Aggiungi pignone" id="pignone" size="small" value={pignone} onChange={(e) => {setPignone(e.target.value)}}/>
        <IconButton aria-label="delete" size="large" onClick={() => {

          if(!pignone || pignone < 1) return

          console.log(pignone)


          const p = pignoni.find(el => el === Number(pignone))

          console.log(p)
          if(p && p > 0) return

          setPignoni([...pignoni,Number(pignone)].sort())

          console.log(pignoni )

        }}>
            <AddCircleIcon />
          </IconButton>
      </Stack>
    </Stack>
    <h3><strong>COMPARAZIONE TABELLA CAMBIO</strong></h3>
    <Stack spacing={2} direction={'row'} flexWrap={'wrap'}>
      <Tabella ruota={ruota} corona={corona} rpm={rpm} pignoni={[...pignoni]} setPignoni={setPignoni}/>
      <Tabella ruota={ruota} corona={corona} rpm={rpm} binary={true} pignoni={[...pignoni]} setPignoni={setPignoni}/>
    </Stack>
    </Stack>
  </Container>)




}

export default Calcolatrice

